var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8.435 8.435C0 16.871 0 30.447 0 57.6v4.8c0 27.153 0 40.729 8.435 49.165C16.871 120 30.447 120 57.6 120h4.8c27.153 0 40.729 0 49.165-8.435C120 103.129 120 89.553 120 62.4v-4.8c0-27.153 0-40.73-8.435-49.165C103.129 0 89.553 0 62.4 0h-4.8C30.447 0 16.87 0 8.435 8.435ZM20.25 36.5c.65 31.2 16.25 49.95 43.6 49.95h1.55V68.6c10.05 1 17.65 8.35 20.7 17.85h14.2C96.4 72.25 86.15 64.4 79.75 61.4c6.4-3.7 15.4-12.7 17.55-24.9H84.4c-2.8 9.9-11.1 18.9-19 19.75V36.5H52.5v34.6c-8-2-18.1-11.7-18.55-34.6h-13.7Z","fill":"#fff"}));
}

LogoInline.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120","fill":"none"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
